import * as woop from "../../../app/core/woop";
import { userHasRight } from "../../../framework";
import { Component, ComponentOptions, RightLockable } from "../../components/components/component";
import { TemplateComponent } from "../../components/components/templateComponent";
import { deepClone } from "../../core/core";
import { bind, observable } from "../../core/kendo";
import { emptyFn } from "../../core/util";
import { updateEntity } from "../../dataComponents/updateEntity";
import K_InsertTab from "../templates/K_InsertTab";

export interface InsertTabOptions extends ComponentOptions {
    components?: Component[];
    entityType?: string;
    insertButtonId?: string;
    cancelButtonId?: string;
    absoluteTabGroupContainerId?: string;
    tabContainerId?: string;
    friendlyEntityName?: string;
    iconType?: string;
    header?: string;
    insertToolTip?: string;
    cancelToolTip?: string;
    bsc?: string;
    labelClasses?: string;
    requiredRight?: string;
}

export class InsertTab extends TemplateComponent {

    options: InsertTabOptions & RightLockable;
    components?: Component[];
    urlPrefix: string;
    beforeSend: any;

    constructor(options: InsertTabOptions) {
        super(K_InsertTab, options);

        this.components = options.components;
    }

    setHeaderBind(headerName) {
        var me = this;

        $(`#${me.id} .insert-object-label`).attr("data-bind", `text: ${headerName}`);
    }

    preRender() {
        const options = this.options;

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.containerClasses += " disabled right-locked";
            }
        }
    }

    initialize(options) {
        var me = this;

        options.absoluteTabGroupContainerId = me.options.absoluteTabGroupContainerId;
        options.tabContainerId = me.options.tabContainerId;
        options.insertButtonId = me.options.insertButtonId;
        options.cancelButtonId = me.options.cancelButtonId;

        options.entityType = options.entityType || me.options.entityType;
        options.friendlyEntityName = options.friendlyEntityName || me.options.friendlyEntityName || options.entityType;
        options.screen = me.options.zScreen;
        options.failToInsert = options.failToInsert || emptyFn;
        options.cancelInsert = options.cancelInsert || emptyFn;
        options.insertedSuccessfully = options.insertedSuccessfully || emptyFn;
        options.errorHandled = options.errorHandled == undefined
            ? false
            : options.errorHandled;

        var get = (options.screen && options.screen.get)
            ? function (selector) { return options.screen.get(selector); }
            : $;

        var expandButton = $(`#${me.id}`);
        var tabGroupContainer = $(`#${options.absoluteTabGroupContainerId}`);
        var tabContainer = get(`#${options.tabContainerId}`);
        var insertButton = get(`#${options.insertButtonId}`);
        var cancelButton = get(`#${options.cancelButtonId}`);

        tabGroupContainer.children().addClass("hidden");
        tabGroupContainer.attr("screenEntityType", options.entityType);
        tabContainer.zValidator();

        if (!options.rightLocked) {
            expandButton.tie("click", function () {
                woop.cancelSelectedWoop();
                options.expandWoop();
                woop.setWoopEnabled(true, options);
            });

            insertButton.bind("click", function () {
                options.insertEntity();
                woop.setWoopEnabled(false, null);
            });

            cancelButton.bind("click", function () {
                options.cancel();
                woop.setWoopEnabled(false, null);
            });

            options.expandWoop = function () {
                options.insertObservable = observable({});
                options.beforeShowInsertContainer && options.beforeShowInsertContainer(options.insertObservable);

                tabGroupContainer.removeClass("hidden");
                tabContainer.removeClass("hidden");
                expandButton.addClass("selected");

                options.setupObservable && options.setupObservable(options.insertObservable);

                bind({ container: tabContainer, bind: ".bind-value", data: options.insertObservable });
            };

            options.insertEntity = options.insertEntity || function () {
                tabGroupContainer.mask();
                var dto = deepClone(options.insertObservable);
                if (options.deleteDtoProperties) {
                    dto = options.deleteDtoProperties(dto);
                }
                var validator = tabContainer.data("kendoValidator");

                let deferred: JQueryDeferred<any>;
                if (options.updateEntity) {
                    deferred = options.updateEntity({ dto, validator });
                } else {
                    deferred = updateEntity({
                        validator: validator,
                        dto: dto,
                        entityType: options.entityType,
                        friendlyEntityName: options.friendlyEntityName,
                        keyField: options.entityType,
                        hideDuplicateMessage: true,
                        urlPrefix: me.urlPrefix,
                        beforeSend: me.beforeSend,
                        errorHandled: options.errorHandled
                    });
                }

                deferred.done(function (args) {
                    options.cancel({ notReallyACancel: true });
                    options.insertedSuccessfully(args.response);
                });

                deferred.fail(function (args) {
                    tabGroupContainer.unmask();
                    options.failToInsert(args.response);
                });
            };

            options.cancel = function (args) {
                args = args || {};

                bind({ container: tabContainer, bind: ".bind-value", unbind: true });

                tabContainer.find("input.bind-value").val("");
                tabContainer.find(".validation-failure").removeClass("validation-failure");

                tabGroupContainer.addClass("hidden");
                tabContainer.addClass("hidden");
                expandButton.removeClass("selected");
                tabGroupContainer.unmask();

                if (!args.notReallyACancel) {
                    options.cancelInsert(options.insertObservable);
                }
            };
        }
    }

    setUrlPrefix(urlPrefix) {
        var me = this;

        me.urlPrefix = urlPrefix;
    }

    setBeforeSend(beforeSend) {
        var me = this;

        me.beforeSend = beforeSend;
    }

}
